



























import Vue from 'vue';

import * as _ from 'lodash';
import moment from "moment";
import { NetworkStatus } from 'apollo-client';

import LoggedInHeader from '@/components/partials/loggedIn/header/LoggedInHeader.vue';
import NavigationHeader from '@/components/partials/NavigationHeader.vue';
import NavigationMenu from '@/components/partials/navigationIconMenu/NavigationMenu.vue';
import Copyright from '@/components/partials/Copyright.vue';
import CookieBanner from '@/components/partials/cookieBanner/CookieBanner.vue';

import { floorRefetchableQuery } from '@/queries/floor';
import { eventBus } from '@/main';

const floorPollInterval = (process.env.WIZ_ENV != 'test' && process.env.WIZ_ENV != 'local-test')
  ? 60000
  : undefined;

export default Vue.extend({
  name: 'App',
  components: {
    LoggedInHeader,
    NavigationHeader,
    NavigationMenu,
    Copyright,
    CookieBanner,
  },
  data(): {
    floorDataIsLoading: boolean;
    keepAliveWrapperId: string;
    excludedKeepAliveRouteNames: string;
    isScenarioEnabled: boolean
  } {
    return {
      floorDataIsLoading: false,
      keepAliveWrapperId: 'router-keep-alive:no-organization',
      excludedKeepAliveRouteNames: 'CreateOrSelectABuildingPage',
      isScenarioEnabled: false,
    };
  },
  apollo: {
    floor: {
      query: floorRefetchableQuery,
      variables(): {
        floorId: string;
      } {
        return { floorId: this.$store.state.user.currentFloorId };
      },
      result({ data, networkStatus }) {
        // The query haven't been run before but started execution
        if (
          _.includes([NetworkStatus.loading, NetworkStatus.refetch], networkStatus)
        ) {
          this.floorDataIsLoading = true;
        }
        // The query have already been executed but started refreshing
        if (
          _.includes([NetworkStatus.setVariables, NetworkStatus.fetchMore, NetworkStatus.refetch, NetworkStatus.poll], networkStatus)
        ) {
          this.$store.dispatch('startCurrentFloorLoading');
        }
        // The query is finished (successfully or not)
        if (
          _.includes([NetworkStatus.ready, NetworkStatus.error], networkStatus)
        ) {
          const isScenarioEnabledResult = _.filter(data?.floor?.featuresActiveUntil, { feature: { name: 'Scenario' } });

          if (isScenarioEnabledResult.length) {
            const { activeUntil } = _.last(isScenarioEnabledResult)
            const isActive = moment(activeUntil).isAfter(moment(), 's') || activeUntil === null;
            this.$store.dispatch('setIsScenarioEnabled', isActive);
            if(!isActive && this.$store.state.user.currentSelectedEntrySettingsPage === 8) {
              this.$router.push({ name: "Settings" });
            }
          } else {
            if(this.$store.state.user.currentSelectedEntrySettingsPage === 8) {
              this.$router.push({ name: "Settings" });
            }
            this.$store.dispatch('setIsScenarioEnabled', false);
          }
          this.floorDataIsLoading = false;
          this.$store.dispatch('stopCurrentFloorLoading');
        }
      },
      notifyOnNetworkStatusChange: true,
      skip(): boolean {
        return (
          this.$store.state.user.currentUser.id == undefined
          || this.$store.state.user.currentUser.organizationId == undefined
          || this.$store.state.user.currentBuildingId == undefined
          || this.$store.state.user.currentFloorId == undefined
        );
      },
      pollInterval: floorPollInterval,
    },
  },
  created() {
    /**
     * 
     * Trigger theses events from any components by:
     * 
     * import { eventBus } from '@/main';
     * ...
     * eventBus.$emit(<event_name>);
     * 
     */
    eventBus.$on('organization-changed', () => this.onOrganizationChanged());
    eventBus.$on('refresh-floor-object', () => this.$apollo.queries.floor.refetch());
  },
  mounted() {
    this.$apollo.queries.floor.refetch();
    this.$store.dispatch('setIsCookieBannerShow', !window.localStorage.getItem('cookiePolicy'));
  },
  computed: {
    navBarShown(): boolean {
      return (
        this.$store.state.user.currentUser.id != undefined
        && this.$store.state.user.currentUser.organizationId != undefined
        && this.$store.state.user.currentBuildingId
        && !(this.$route.matched[0] && this.$route.matched[0].meta.hidesNavbar)
        && this.$route.name !== 'RestorePasswordPage'
        && this.$route.name !== 'AccountActivation'
        && this.$route.name !== 'AuthorizeExternalServicePage'
        && this.$route.name !== 'FillOrganizationDetails'
        && this.$route.name !== 'WelcomeSignup'
        && this.$route.name !== 'AcceptOrganizationInvitation'
        && this.$route.name !== 'WallPanelWithRoomId'
        && this.$route.name !== 'Profile'
      );
    },
    loggedInHeaderShown(): boolean {
      return (
        this.$store.state.user.currentUser.id != undefined
        && this.$route.name !== 'WallPanel'
        && this.$route.name !== 'WallPanelWithRoomId'
        && this.$route.name !== 'RestorePasswordPage'
        && this.$route.name !== 'AccountActivation'
        && this.$route.name !== 'AuthorizeExternalServicePage'
      );
    },
    isResponsiveLayout(): boolean {
      if(this.$route.meta?.responsiveLayout) {
        const { responsiveLayout } = this.$route.meta;
        return responsiveLayout === true;
      }
      return false;
    },
  },
  methods: {
    onOrganizationChanged() {
      this.keepAliveWrapperId = this.generateKeepAliveWrapperId();
    },
    generateKeepAliveWrapperId(): string {
      const prefix = 'router-keep-alive';
      let organizationId: string;
      if (this.$store.state.user.currentUser.organizationId != undefined) {
        organizationId = this.$store.state.user.currentUser.organizationId;
      } else {
        organizationId = 'no-organization';
      }
      return `${prefix}:${organizationId}`;
    },
  },
});
